<!--suppress ALL -->

<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <div class="leftSection">
            <div class="header-title wrapper-content__main font-weight__bold">
              Văn bản chờ ban hành
            </div>
          </div>
        </template>
      </headerTemplate>
    </template>

    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <div >
                  <el-button
                    size="medium"
                    type="success"
                    class="createNew"
                    @click="isOpenDialogCreate = true"
                  >
                    <div class="flex-row flex__center">
                      <i class="fas fa-file-plus"></i>
                      <span>&nbsp;&nbsp;THÊM MỚI</span>
                    </div>
                  </el-button>

                </div>
                <div class=" margin-left-10">
                  <el-button
                    size="medium"
                    type="success"
                    class="createNew"
                    @click="isOpenMultiScanDocOutDialogCreate = true"
                  >
                    <div class="flex-row flex__center">
                      <i class="fas fa-search"></i>
                      <span>&nbsp;&nbsp;SCAN</span>
                    </div>
                  </el-button>
                </div>
                <div class="margin-left-10">

                  <!--                hoang xuất kêt quả tìm kiếm -->
                  <el-tooltip class="item" effect="dark" content="Kết xuất kết quả tìm kiếm" placement="top-end">
                    <el-button
                      size="medium"
                      @click="chosenFileType"
                      type="primary">
                      <div class="flex-row flex__center">
                        <i class="fas fa-file-export"></i>
                        <span>&nbsp;KẾT XUẤT</span>
                      </div>
                    </el-button>
                  </el-tooltip>
                </div>
                <searchTemplate
                  :keyword="keyword"
                  @search="isOpenAdvanceSearchDialog = true"
                  @simpleSearch="simpleSearch"
                >
                  <template #quickFilter>
<!--                    <div-->
<!--                      class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large"-->
<!--                    >-->
<!--                      <span class="label-input width__auto"-->
<!--                      >Ngày ký duyệt:-->
<!--                      </span>-->
<!--                      <el-date-picker-->
<!--                        v-model="signerTimeRange"-->
<!--                        type="daterange"-->
<!--                        format="dd/MM/yyyy"-->
<!--                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"-->
<!--                        :picker-options="dateQuickFilterOption"-->
<!--                        range-separator="_"-->
<!--                        start-placeholder="_"-->
<!--                        end-placeholder="_"-->
<!--                        align="center"-->
<!--                        :clearable="false"-->
<!--                        @change="filterBySignerTimeRange"-->
<!--                      >-->
<!--                      </el-date-picker>-->
<!--                    </div>-->

                    <div class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large">
                      <span class="label-input width__auto"
                      >Ngày ký duyệt:
                      </span>
                      <span class="label-input width__auto">Từ ngày:</span>
                      <el-date-picker
                        v-model="fromSignerTime"
                        type="date"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        placeholder="Chọn ngày bắt đầu"
                        align="right"
                        :clearable="false"
                        @change="filterBySignerTimeRange"
                      ></el-date-picker>
                    </div>

                    <div class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large">
                      <span class="label-input width__auto">Đến ngày:</span>
                      <el-date-picker
                        v-model="toSignerTime"
                        type="date"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        placeholder="Chọn ngày kết thúc"
                        align="right"
                        :clearable="false"
                        @change="filterBySignerTimeRange"
                      ></el-date-picker>
                    </div>
                  </template>
                  <template #advance>
                    <chobanhanh-advance-search
                      :isOpen="isOpenAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                    />
                  </template>
                </searchTemplate>
              </template>
            </subHeader>
          </template>

          <template #body>
            <div class="list">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <div class="leftSection flex-row flex__left">
                  <div class="theTitle theTitle__lv5">
                    STT
                  </div>
                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left clickable"
                    @click="doSort('quote')"
                  >
                    Trích yếu
                    <sort-caret :order="order" :sort="sort" :field="'quote'"/>
                  </div>
                </div>
                <div class="rightSection flex-row flex__right ">
                  <div
                    class="theTitle theTitle__lv2 flex-row flex__left clickable"
                    @click="doSort('signerName')"
                  >
                    Người ký duyệt
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'signerName'"
                    />
                  </div>

                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left clickable"
                    @click="doSort('signerTime')"
                  >
                    Thời gian ký duyệt
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'signerTime'"
                    />
                  </div>
                </div>
              </div>
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in outgoingDocs"
                    v-bind:key="$itemIndex"
                    class="item flex-row flex__between clickable"
                    @click="viewDetailDocs(item)"
                  >
                    <div class="leftSection flex-row flex__left">
                      <div class="theTitle__lv5">
                        <div class="flex-row flex__left">
                          <div class="section-check">
                            <span class="stt flex-row flex__center">{{
                                $itemIndex + 1
                              }}</span>
                          </div>
                          <i
                            class="fas fa-file color__silver"
                            @click.stop="
                              downloadAttachment(
                                item,
                                ATTACHMENT_OBJECT_TYPE.VB_DI
                              )
                            "
                          ></i>
                        </div>
                      </div>
                      <div class="theTitle__lv1 margin-right-10">
                        <div class="title-docs flex-col flex__left">
                          <div class="tt_1 clickable">
                            {{ item.quote }}
                          </div>
                          <div class="tt_2 flex-row flex__left">
                            <span v-if="item.docCode"
                            >#{{ item.docCode }}&nbsp;&nbsp;</span
                            >
                            <el-tag
                              v-if="item.docTypeName"
                              size="mini"
                              :class="['priority', 'lv3']"
                            >{{ item.docTypeName }}
                            </el-tag>

                            <el-tag
                              v-if="isShowPiority(item.priorityId)"
                              size="mini"
                              :class="[
                                'priority',
                                getPiorityClass(item.priorityId)
                              ]"
                            >
                              <i class="fas fa-bolt"></i>
                              <span>
                                {{ item.priorityName }}
                              </span>
                            </el-tag>
                            <span>
                               <el-tooltip
                                 content="Văn bản điện tử"
                                 placement="top"
                                 effect="dark"
                                 v-if="isVbDienTu(item)"
                               >
                                 <div class="eIcon">e</div>
                               </el-tooltip>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightSection flex-row flex__right">
                      <div
                        class="theTitle__lv2 flex-row flex__left font-size__small"
                      >
                        <div class="flex-row flex__left">
                          <displayPeople
                            :name="item.signerName"
                            v-if="item.signerName"
                          />
                          <span v-else>-</span>
                        </div>
                      </div>
                    </div>

                    <div class="rightSection flex-row flex__right">
                      <div
                        class="theTitle__lv3 flex-row flex__left font-size__small"
                      >
                        <div class="flex-row flex__right">
                          <i class="cellIcon color__silver fas fa-clock"></i>
                          {{
                            item.signerTime | dateFormatter({nullValue: "-"})
                          }}
                        </div>
                      </div>
                    </div>

                    <div class="theQuickAction flex-row flex__right">
                      <el-tooltip content="In phiếu xử lý" placement="top">
                        <i
                          @click.stop="inPhieuTrinhKi(item)"
                          class="action-icon bgAmbient__green clickable fas fa-print"
                        ></i>
                      </el-tooltip>
                      <el-tooltip
                        content="Xóa văn bản"
                        placement="top"
                        v-if="isEnableDelete(item)"
                      >
                        <i
                          class="action-icon bgAmbient__red clickable fas fa-trash"
                          @click.stop="delete_(item)"
                        ></i>
                      </el-tooltip>
                    </div>
                  </div>

                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không có dữ liệu</div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
          </template>
        </listTemplate>
      </div>
      <createDialog
        :isOpen="isOpenDialogCreate"
        v-if="isEnableDialogCreate"
        @closed="isEnableDialogCreate = false"
        @closeDialog="isOpenDialogCreate = false"
        @success="createDocSuccess"
      />
      <BHanhDocOutDialog
        :isOpen="isOpenBHanhDocOut"
        :quote="docAfterSave.quote"
        :docId="docAfterSave.id"
        :docStatus="docAfterSave.status"
        :publisherId="docAfterSave.publisherId"
        :docTypeId="docAfterSave.docTypeId"
        :deptEditorId="docAfterSave.deptEditorId"
        :otherReceivePlaces="docAfterSave.otherReceivePlaces"
        :docReceiverIds="docAfterSave.receiveDepartmentIds"
        v-if="isEnableBHanhDocOut"
        @closed="isEnableBHanhDocOut = false"
        @closeDialog="isOpenBHanhDocOut = false"
        @success="banHanhVanThuSuccess"
      />
      <multi-scan-cho-ban-hanh-dialog
        :isOpen="isOpenMultiScanDocOutDialogCreate"
        v-if="isEnableMultiScanDocOutDialogCreate"
        @closed="isEnableMultiScanDocOutDialogCreate = false"
        @closeDialog="isOpenMultiScanDocOutDialogCreate = false"
        @success="createMultiScanDocSuccess"
      />
      <chosen-file-type-dialog
        v-if="isOpenChosenFileTypeDialog"
        @closeDialog="isOpenChosenFileTypeDialog= false"
        @exportResult="exportResult"
        :is-open="true">
      </chosen-file-type-dialog>
    </template>
  </listTemplate>
</template>
<script>
import BreakWordSpan from "../adminstration/ketluan/break-word-span";
import BHanhDocOutDialog from "./components/BHanhDocOutDialog";

import buildShortNameFilter from "../../filters/buildShortNameFilter";
import outGoingDocSevice from "../../services/outgoingDocService";
import dateFormatter from "../../filters/dateFormatter";
import constants from "../../constants";
import utils from "../../services/utils";
import {EventBus} from "../../event-bus.js";
import dateUtils from "../../dateUtils";
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import buildAttachmentURL from "../../filters/buildAttachmentURL";
import ChobanhanhAdvanceSearch from "./components/chobanhanh-advance-search";
import handleRequestErrorMixin from "../handleRequestErrorMixin";
import h from "../../services/h";
import chosenFileTypeDialog from "./chosenFileTypeDialog";
import MultiScanChoBanHanhDialog from "./multi-scan-cho-ban-hanh-dialog";
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  components: {
    MultiScanChoBanHanhDialog,
    chosenFileTypeDialog,
    BreakWordSpan,
    ChobanhanhAdvanceSearch,
    InfiniteLoading: () => import("vue-infinite-loading"),
    createDialog: () => import("./components/CreateKyNgoaiDialog.vue"),
    listTemplate: () => import("../common/list.vue"),
    headerTemplate: () => import("../../components/header/main-header.vue"),
    searchTemplate: () => import("../common/search.vue"),
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
    subHeader: () => import("../../components/main/sub-header.vue"),
    SortCaret: () => import("./SortCaret"),
    displayPeople: () => import("../common/displayPeople.vue"),
    BHanhDocOutDialog
  },

  mixins: [vbAttachmentTokenMixin, handleRequestErrorMixin],
  filters: {dateFormatter, buildShortNameFilter, buildAttachmentURL},

  data() {
    return {
      isOpenMultiScanDocOutDialogCreate: false,
      isEnableMultiScanDocOutDialogCreate: false,

      isOpenChosenFileTypeDialog: false,

      sortList: [],
      isOpenDialogCreate: false,
      isEnableDialogCreate: false,

      ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
      dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),

      isOpenAdvanceSearchDialog: false,
      isEnableAdvanceSearchDialog: false,
      perfectScrollbarSetting: {maxScrollbarLength: 350},

      isOpenBHanhDocOut: false,
      isEnableBHanhDocOut: false,
      docAfterSave: null,

      outgoingDocs: [],

      page: 0,
      size: 10,
      advanceSearchForm: {},
      sort: null,
      order: null,
      keyword: null,
      signerTimeRange: [null, null],
      fromSignerTime:null,
      toSignerTime:null
    };
  },

  mounted() {
    EventBus.$on(this.currentRoute, options => {
      this.doSearch();
    });
  },

  computed: {
    currentRoute() {
      return this.$route.path.split("/")[3];
    },
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
    dateRange() {
      return this.$route.params.dateRange;
    },
    ...mapState("outgoingDocs", ["eventData"]),
    ...mapGetters("outgoingDocs", ["requiresListReload"]),
  },

  watch: {
    isOpenBHanhDocOut(newValue) {
      newValue && (this.isEnableBHanhDocOut = newValue);
    },
    isOpenMultiScanDocOutDialogCreate(newValue) {
      newValue && (this.isEnableMultiScanDocOutDialogCreate = newValue);
    },

    isOpenDialogCreate: function (newValue) {
      newValue && (this.isEnableDialogCreate = newValue);
    },
    isOpenAdvanceSearchDialog: function (newValue) {
      newValue && (this.isEnableAdvanceSearchDialog = newValue);
    },
    eventData(newEvent) {
      if (this.requiresListReload) {
        console.log(`Reloading list due to event ${newEvent.action}`);
        this.doSearch()
        this.clearEvent(); // Reset the event after handling
      }
    }
  },

  created() {
    this.initQuery();
    this.setDefaultDocDateRange();
    this.filterBySignerTimeRange();
  },

  methods: {
    ...mapActions("outgoingDocs", ["clearEvent"]),

    createMultiScanDocSuccess() {
      this.message("Thông báo", "Scan văn bản thành công", "success", 2000)
      this.isOpenMultiScanDocOutDialogCreate = false;
      EventBus.$emit('loadCounting', '');
      this.doSearch();
    },
    isVbDienTu(item) {
      if(item.eFlag&&item.eFlag==='1'){
        return true;
      }else {
        return false;
      }
    },
    inPhieuTrinhKi(item) {
      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.IN_PHIEU.VB_DI;
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize({docId: item.id})}`,
      );
    },

    chosenFileType() {
      this.isOpenChosenFileTypeDialog = true
    },
    exportResult(item) {
      this.isOpenChosenFileTypeDialog = false
      this.exportSearchResult(item, 'VB_CHO_BAN_HANH')
    },

    isEnableDelete(item) {
      return (
        item &&
        item.isKyNgoai == constants.OUTGOING_DOC.IS_KY_NGOAI.TRUE &&
        item.status == constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH &&
        item.publisherId == this.$store.getters.userDeptRole.deptId &&
        this.$store.getters.userDeptRole.roleCode == constants.ROLE.CODE.VAN_THU
      );
    },

    delete_(item) {
      this.$confirm(`Bạn có muốn xóa văn bản "${item.quote}" ?`, "Thông báo", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy bỏ",
        type: "warning"
      }).then(() => {
        outGoingDocSevice
          .deleteForVanThu(item.id)
          .then(respone => {
            this.$message({
              message: "Xóa thành công",
              type: "success",
              duration: 2000
            });
            EventBus.$emit('loadCounting', '');
            this.doSearch();
          })
          .catch(error => this.commonHandleRequestError(error));
      });
    },

    banHanhVanThuSuccess() {
      this.isOpenBHanhDocOut = false;
      this.doSearch();
    },

    createDocSuccess(event) {
      this.docAfterSave = event.doc;
      this.isOpenDialogCreate = false;
      this.isOpenBHanhDocOut = true;
      this.doSearch();
    },

    initDateRange() {
      this.signerTimeRange =
        (this.dateRange && dateUtils.getDatesByQuickFilter(this.dateRange)) ||
        dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
        );
      this.fromSignerTime = this.signerTimeRange[0].getTime();
      this.toSignerTime = this.signerTimeRange[1].getTime();
    },

    // filterBySignerTimeRange(event) {
    //   this.advanceSearchForm.fromSignerTime =
    //     this.signerTimeRange && this.signerTimeRange[0]
    //       ? this.signerTimeRange[0].getTime()
    //       : undefined;
    //   this.advanceSearchForm.toSignerTime =
    //     this.signerTimeRange && this.signerTimeRange[1]
    //       ? this.signerTimeRange[1].getTime()
    //       : undefined;
    //   this.doSearch();
    // },

    setDefaultDocDateRange() {
      const startDate = new Date(new Date().getFullYear(), 0, 1);
      this.fromSignerTime = startDate;
    },

    filterBySignerTimeRange(event) {
      const a = this.isValidDate(this.fromSignerTime);
      const b = this.isValidDate(this.toSignerTime);

      if ((this.fromSignerTime === null || !a) && (this.toSignerTime === null || b)) {
        this.fromSignerTime = new Date(new Date().getFullYear(), 0, 1);
      } else if ((this.toSignerTime === null || !b) && (this.fromSignerTime === null || a)) {
        this.toSignerTime = new Date(new Date().getFullYear(), 11, 31);
      } else if (this.fromSignerTime > this.toSignerTime) {
        this.fromSignerTime = new Date(new Date().getFullYear(), 0, 1);
        this.toSignerTime = new Date(new Date().getFullYear(), 11, 31);
      }

      this.advanceSearchForm.fromSignerTime = this.fromSignerTime ? this.fromSignerTime.getTime() : undefined;
      this.advanceSearchForm.toSignerTime = this.toSignerTime ? this.toSignerTime.getTime() : undefined;
      this.doSearch();
    },

    isValidDate(date) {
      return date instanceof Date && !isNaN(date);
    },

    initQuery() {
      this.sort = this.$route.query.sort || "updateTime";
      this.order = this.$route.query.order || "desc";
      this.advanceSearchForm = {
        keyword: this.$route.query.keyword || undefined,
        fromSignerTime: this.$route.query.fromSignerTime
          ? parseInt(this.$route.query.fromSignerTime)
          : undefined,
        toSignerTime: this.$route.query.toSignerTime
          ? parseInt(this.$route.query.toSignerTime)
          : undefined,
        docTypeId: this.$route.query.docTypeId
          ? parseInt(this.$route.query.docTypeId)
          : undefined,
        priorityId: this.$route.query.priorityId
          ? parseInt(this.$route.query.priorityId)
          : undefined,
        quote: this.$route.query.quote || undefined,
        otherReceivePlaces: this.$route.query.otherReceivePlaces || undefined,
        receiveDeptId: this.$route.query.receiveDeptId || undefined,
        fileContent: this.$route.query.fileContent || undefined
      };
      this.keyword = this.advanceSearchForm.keyword;
      this.initSignerTimeRange();
    },

    buildQuery() {
      return utils.merge(
        {sort: this.sort || "updateTime", order: this.order || "desc"},
        this.advanceSearchForm
      );
    },

    initSignerTimeRange() {
      if (
        this.advanceSearchForm.fromSignerTime ||
        this.advanceSearchForm.toSignerTime
      ) {
        this.signerTimeRange = [
          dateUtils.toMoment(this.advanceSearchForm.fromSignerTime),
          dateUtils.toMoment(this.advanceSearchForm.toSignerTime)
        ];
      } else {
        this.signerTimeRange = dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
        );
        let defaultTimeRange = dateUtils.getTimesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
        );
        this.advanceSearchForm.fromSignerTime = defaultTimeRange[0];
        this.advanceSearchForm.toSignerTime = defaultTimeRange[1];
      }
    },

    simpleSearch(keyword) {
      this.keyword = this.advanceSearchForm.keyword = keyword;
      this.advanceSearchForm.docTypeId = undefined;
      this.advanceSearchForm.priorityId = undefined;
      this.advanceSearchForm.quote = undefined;
      this.advanceSearchForm.otherReceivePlaces = undefined;
      this.advanceSearchForm.receiveDeptId = undefined;
      this.advanceSearchForm.fileContent = undefined;
      this.doSearch();
    },

    advanceSearch(event) {
      let advanceSearchForm = event.advanceSearchForm;
      this.sortList = event.sortList;
      this.advanceSearchForm.keyword = undefined;
      this.keyword = null;
      this.advanceSearchForm.quote = advanceSearchForm.quote || undefined;
      this.advanceSearchForm.priorityId =
        advanceSearchForm.priorityId || undefined;
      this.advanceSearchForm.docTypeId =
        advanceSearchForm.docTypeId || undefined;
      this.advanceSearchForm.receiveDeptId =
        advanceSearchForm.receiveDeptId || undefined;
      this.advanceSearchForm.otherReceivePlaces =
        advanceSearchForm.otherReceivePlaces || undefined;
      this.advanceSearchForm.fileContent =
        advanceSearchForm.fileContent || undefined;
      this.advanceSearchForm.sortList =
        event.sortList || undefined;
      this.doSearch();
    },

    doSort(sort) {
      let order =
        sort == this.sort ? (this.order == "asc" ? "desc" : "asc") : "asc";
      this.sort = sort;
      this.order = order;
      this.doSearch();
    },

    doSearch() {
      this.$router.replace({
        name: this.$router.name,
        params: this.$route.params,
        query: this.buildQuery()
      });

      this.outgoingDocs = [];
      this.page = 0;
      this.$nextTick(() => this.$refs.infiniteLoading.stateChanger.reset());
    },

    infiniteHandler($state) {
      this.list().then(items => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    list() {
      let pageable
      if (this.sortList && this.sortList.length > 0) {

        let sort = [];
        h.each(this.sortList, (item) => {
          sort.push(item);
        })
        pageable = {
          page: this.page,
          size: this.size,
          sort: sort
        };
      } else {
        pageable = {
          page: this.page,
          size: this.size,
          sort: [this.sort, this.order].join(",")
        };
      }


      let advanceSearchForm = utils.merge(this.advanceSearchForm, {
        status: constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH
      });

      return outGoingDocSevice
        .listChoBanHanh2(advanceSearchForm, pageable)
        .then(response => {
          let items = response.data;
          items && this.outgoingDocs.push(...items);
          return items;
        });
    },
    exportSearchResult(fileType, name) {
      let pageable
      if (this.sortList && this.sortList.length > 0) {

        let sort = [];
        h.each(this.sortList, (item) => {
          sort.push(item);
        })
        pageable = {
          page: 0,
          size: 1000,
          sort: sort
        };
      } else {
        pageable = {
          page: 0,
          size: 1000,
          sort: [this.sort, this.order].join(",")
        };
      }


      let advanceSearchForm = utils.merge(this.advanceSearchForm, {
        status: constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH
      });
      let params = utils.merge(advanceSearchForm, pageable)
      params.userId = this.$store.getters.userDeptRole.userId;
      params.deptId = this.$store.getters.userDeptRole.deptId;
      params.roleId = this.$store.getters.userDeptRole.roleId;
      params.positionId = this.$store.getters.userDeptRole.positionId;
      params.fileType = fileType
      params.name = name

      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.IN_PHIEU.SEARCH_RESULT_VB_CHO_BAN_HANH;
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize(params)}`
      );

      // return outGoingDocSevice
      //   .listChoBanHanh2(advanceSearchForm, pageable)
      //   .then(response => {
      //     let items = response.data;
      //     items && this.outgoingDocs.push(...items);
      //     return items;
      //   });
    },

    getPiorityClass(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    isShowPiority(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1;
    },

    viewDetailDocs(item) {
      item.isSeen = 1;
      this.$router.push({
        name: "vbChoBanHanhDetail",
        params: {userDeptRoleId: this.userDeptRoleId, id: item.id},
        query: this.$route.query
      });
    }
  }
};
</script>
<style scoped>
#searchBox {
  position: relative;
  width: 100%;
}

.advance-search {
  font-size: 17px;
  color: #005eb1;
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
}

.icon-very__small {
  height: 14px;
  padding-top: 4px;
}

.icon-info {
  background-color: #f0c330;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-top: -1px;
  margin-left: 2px;
}
.eIcon{
  border: solid 1px #007aff;
  border-radius: 2px;
  padding: 0px 3px;
  font-size: 11px;
  color: goldenrod;
  margin-left:2px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/VbChoBanHanhIndex.vue